// App utils
import { datajs } from '../shared/utils';

export default class FixedHeader {
	static init() {
		let initialLoad = true;
		let throttled = false;
		let ticking = false;
		let lastScrollTop = 0;
		const delta = 5;
		const siteHeader = datajs('site-header');

		if (!siteHeader) {
			return;
		}

		const scrollThreshold = siteHeader.offsetHeight;

		if (!window.requestAnimationFrame) {
			return;
		}

		const updateCssVars = () => {
			document.documentElement.style.setProperty('--site-header-height', siteHeader.offsetHeight / 16 + 'rem');
		};

		const update = () => {
			ticking = false;
			const st = window.pageYOffset || document.documentElement.scrollTop;

			if (Math.abs(lastScrollTop - st) <= delta) {
				return;
			}

			// Don't do anything while takeover menu is open
			if (document.body.classList.contains('has-activated-menu')) {
				return;
			}

			// If current position > last position AND scrolled past navbar...
			if (st > lastScrollTop && st > scrollThreshold) {
				// Scroll Down
				document.body.classList.add('is-scrollingDown');
				document.body.classList.remove('is-scrollingUp');
			} else if (st < lastScrollTop && st > scrollThreshold) {
				// Scroll Up
				document.body.classList.add('is-scrollingUp');
				document.body.classList.remove('is-scrollingDown');
			} else if (st <= delta) {
				document.body.classList.remove('is-scrollingUp');
			} else {
				document.body.classList.remove('is-scrollingDown');
			}

			lastScrollTop = st;
		};

		const requestTick = () => {
			if (!ticking) {
				window.requestAnimationFrame(update);
			}
			ticking = true;
		};

		// Hide nav if page is reloaded in the middle of the page
		if (initialLoad) {
			let st = window.pageYOffset || document.documentElement.scrollTop;
			initialLoad = false;

			if (st > scrollThreshold) {
				document.body.classList.add('is-scrollingDown');
			}
		}

		window.addEventListener('scroll', requestTick, {
			capture: false,
			passive: true,
		});

		// Throttled Resize handler
		window.addEventListener(
			'resize',
			function () {
				if (!throttled) {
					updateCssVars();
					throttled = true;
					setTimeout(function () {
						throttled = false;
					}, 100);
				}
			},
			{
				capture: false,
				passive: true,
			}
		);

		// Run once first
		updateCssVars();
	}
}
